// extracted by mini-css-extract-plugin
export default {"Paragraph":"ProductParagraph_Paragraph__mfuVT"};